import * as Flags from "country-flag-icons/react/3x2";
import * as React from "react";
import { ForwardedRef, forwardRef, SyntheticEvent } from "react";
import { t } from "i18next";
import {
  AppAutoCompleteProps,
  AppFlagSelectProps,
  AppSelectProps,
} from "./AppSelect.props";
// import {
//   Autocomplete,
//   createFilterOptions,
//   InputAdornment,
//   InputLabel,
//   MenuItem,
//   OutlinedInput,
//   Select,
//   SelectChangeEvent,
//   TextField,
//   Typography,
// } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { createFilterOptions } from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { SelectChangeEvent } from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { KeyboardArrowDown } from "@mui/icons-material";
import { useSelectOptionsStyles as useSelectFlagOptionsStyles } from "./AppSelect.styles";
import { SingleOptionType } from "../../../@types/FormFields";

let rounded = {
  borderRadius: "3rem",
  borderColor: "white",
  borderWidth: "0.1rem",
};
let defaultStyle = {
  borderRadius: "0.2rem",
};

function setSelectStyles(styles) {
  defaultStyle = {
    ...defaultStyle,
    ...styles,
  };
  rounded = {
    ...rounded,
    ...styles,
  };
}
export { AppDropDownSelect as default };
export const AppDropDownSelect = forwardRef(function AppDropDownSelect(
  {
    label,
    required = false,
    selectStyles = {},
    className = "",
    value = "",
    onChange = () => {},
    options = [],
    rounded: isRounded,
    readOnly = false,
  }: AppSelectProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  setSelectStyles(selectStyles);
  const SelectStyleClasses = useSelectFlagOptionsStyles();

  return (
    <div
      className={`w-full h-full flex flex-row gap-2 items-center justify-center  ${className} ${SelectStyleClasses.standard}`}
    >
      <div>
        <InputLabel
          className="w-full whitespace-nowrap "
          style={{ overflow: "visible" }}
        >
          <Typography>
            {label}
            {required && <span className="text-red-600"> *</span>}
          </Typography>
        </InputLabel>
      </div>
      <div className={"w-full flex flex-col"}>
        <Select
          ref={ref}
          disabled={readOnly}
          displayEmpty
          value={value}
          onChange={(e) => {
            onChange(e.target.value, e);
          }}
          sx={isRounded ? { ...rounded } : { ...defaultStyle }}
          input={<OutlinedInput required={required} />}
        >
          <MenuItem value={""} disabled={true}>
            <div className="flex flex-row w-full h-full flex items-center box-border pl-2 text-gray-500">
              {t("Select")}
            </div>
          </MenuItem>
          {options.map((el, index) => {
            let label: string = el.toString();
            let value: undefined | any = el.toString();
            if (typeof el != "string") {
              label = el.label;
              value = el.value;
            }
            return (
              <MenuItem value={value} key={index}>
                <div className="flex flex-row w-full h-full flex items-center justify-center box-border pl-2">
                  {<div>{label}</div>}
                </div>
              </MenuItem>
            );
          })}
        </Select>
      </div>
    </div>
  );
});

export const AppDropDownWithSearch = forwardRef(function AppDropDownWithSearch(
  {
    label,
    required = false,
    className = "",
    value = "",
    onChange = () => {},
    options = [],
    readOnly = false,
    showlabel = false,
    containerheight = "",
    containerwidth = "",
    onInputChange = () => {},
    showlabelOnShrink = true,
    isMargin = false,
    InputColor = false,
    fontFamilyForLabel = "",
    fontFamilyForInput = "",
    disableInput = false,
    ...props
  }: AppAutoCompleteProps,
  ref: ForwardedRef<HTMLInputElement>
) {
  const filterOptions = createFilterOptions({
    limit: 50,
    matchFrom: "start",
  });

  const [isShowingOptions, setIsShowingOptions] = React.useState(false);

  const effectiveFontInput =
    fontFamilyForInput || "MBCorpoAScreen1Cond-Regular-Web";
  const effectiveFontLabel = fontFamilyForLabel || effectiveFontInput;

  return (
    <div className={`w-full ${className}`}>
      <Autocomplete
        ref={ref}
        disableClearable
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        disabled={readOnly || props.disabled}
        value={value || ""}
        options={options.sort()}
        open={isShowingOptions}
        renderOption={(e: React.HTMLAttributes<HTMLLIElement>, option) => {
          const currentOption = option as SingleOptionType;
          let label: string = currentOption.toString();
          let value: any = currentOption.toString();
          let icon: undefined | JSX.Element;
          if (typeof currentOption != "string") {
            label = currentOption.label;
            value = currentOption.value;
            icon = currentOption.icon;
          }
          return (
            <div
              className="box-border py-2 pl-2 cursor-pointer flex flex-nowrap items-center"
              key={value}
              onClick={(e) => {
                onChange(value as string, e);
                setIsShowingOptions(false);
              }}
              style={{ fontFamily: effectiveFontInput }}
            >
              {icon && <InputAdornment position="start">{icon}</InputAdornment>}
              {label}
            </div>
          );
        }}
        onChange={(e, value) => {
          onChange(value as string, e);
        }}
        filterOptions={filterOptions}
        renderInput={(params) => (
          <>
            {showlabel && (
              <div style={{ marginBottom: "7px" }}>
                <label
                  style={{
                    color: "#FFFFFF",
                    fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                  }}
                >
                  {label}
                </label>
              </div>
            )}
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                sx: {
                  height: containerheight,
                  fontFamily: effectiveFontInput,
                },
              }}
              inputProps={{
                ...params.inputProps,
                readOnly: disableInput,
                sx: {
                  marginTop: containerheight === "38px" ? "-9px" : "0px",
                  fontFamily: effectiveFontInput,
                },
              }}
              InputLabelProps={
                showlabelOnShrink
                  ? {
                      sx: {
                        "&.MuiInputLabel-root": {
                          fontFamily: effectiveFontLabel,
                          marginTop: isMargin ? "5px" : "-8px",
                        },
                        "&.MuiInputLabel-shrink": {
                          marginTop: "13px",
                          color: "#00ADEF",
                          fontFamily: effectiveFontLabel,
                          display: "none",
                        },
                      },
                    }
                  : {
                      sx: {
                        "&.MuiInputLabel-root": {
                          fontFamily: effectiveFontLabel,
                          marginTop: "-8px",
                        },
                        "&.MuiInputLabel-shrink": {
                          display: "none",
                        },
                      },
                    }
              }
              onChange={() => {
                if (!isShowingOptions) setIsShowingOptions(!isShowingOptions);
              }}
              onBlur={() => setIsShowingOptions(false)}
              onClick={() => setIsShowingOptions(!isShowingOptions)}
              disabled={props.disabled || readOnly}
              label={label}
              required={required}
              style={{
                width: containerwidth,
                height: containerheight,
                backgroundColor: InputColor ? "#D9D9D9" : "#FFFFFF",
                borderRadius: "8px",
              }}
              onKeyDown={disableInput ? (e) => e.preventDefault() : undefined}
            />
          </>
        )}
        onInputChange={(e: SyntheticEvent) => {
          if (!e) return;
          onInputChange(e.target.value || "");
        }}
        fullWidth
      />
    </div>
  );
});
AppFlagSelect.propTypes = AppFlagSelectProps;
AppFlagSelect.defaultProps = {
  selectStyles: {},
  className: "'",
  dropDownIcon: <KeyboardArrowDown />,
  onChange: () => {},
};

export function AppFlagSelect({
  options,
  value,
  selectStyles,
  className,
  dropDownIcon,
  onChange,
}) {
  const SelectStyles = useSelectFlagOptionsStyles(selectStyles);
  const getFlagComponent = (countryCode) => {
    if (countryCode === "us" || countryCode === "en") {
      return (
        <img
          src="/assets/icons/united-states.png"
          className="max-w-6 max-h-6"
        />
      );
    } else if (countryCode === "it") {
      return <img src="/assets/icons/italy.png" className="max-w-6 max-h-6" />;
    }
    const Flag = Flags[countryCode.toString().toUpperCase()];
    return Flag && <Flag className="max-w-4 max-h-4" />;
  };
  return (
    <div className={"w-full h-full" + " " + className}>
      <Select
        IconComponent={() => dropDownIcon}
        fullWidth
        className={SelectStyles.flagged}
        value={value || ""}
        onChange={(e: SelectChangeEvent) => {
          onChange(e.target.value, e || "");
        }}
      >
        {options.map((countryCode, index) => {
          return (
            <MenuItem className="w-16" value={countryCode} key={index}>
              {getFlagComponent(countryCode)}
            </MenuItem>
          );
        })}
      </Select>
    </div>
  );
}
